import React, { useState } from 'react';
import { Upload } from './Upload';
import { UnsplashSearch } from './UnsplashSearch';
import { useFeatureFlag } from '@trello/feature-flag-client';

interface AddCoverProps {
  cardId: string;
  navigateToSelectCover: () => void;
}

export const AddCover: React.FunctionComponent<AddCoverProps> = ({
  cardId,
  navigateToSelectCover,
}) => {
  const colorAndFullCoversEnabled = useFeatureFlag('remarkable.rmk-239', false);

  const [isUploading, setIsUploading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const onSetCover = () => {
    navigateToSelectCover();
  };

  return (
    <>
      {!isUploading && (
        <UnsplashSearch
          cardId={cardId}
          onSetCover={onSetCover}
          onSetSearching={setIsSearching}
        />
      )}
      {!isSearching && !colorAndFullCoversEnabled && (
        <>
          <Upload
            cardId={cardId}
            onFileSelected={() => {
              setIsUploading(true);
            }}
            onFileUploaded={() => {
              onSetCover();
            }}
            onUploadFailed={() => {
              setIsUploading(false);
            }}
          />
        </>
      )}
    </>
  );
};
